export const navRoute = {
  navigateToFoodBox: '/food-boxes',
  navigateToCalendar: '/calendar',
};
